import {Badge, Box, Button, Flex, HStack, SimpleGrid, Text, useDisclosure, VStack,} from "@chakra-ui/react"

import {Parts, UI} from "components"
import useBestReferral from "hooks/useBestReferral"

export default function BestReferral() {
    const {data} = useBestReferral()
    const dialog = useDisclosure()

    const rawData = data?.data || data || []
    const registrations = Array.isArray(rawData) ? rawData : rawData?.registrations || []

    const prizes = {
        first: data?.first_place || data?.fist_place || 0,
        second: data?.second_place || 0,
        third: data?.third_place || 0
    }

    const sorted = [...(registrations || [])]
        .sort((a, b) => b.total_registrations - a.total_registrations)
        .slice(0, 15)

    const podium = sorted.slice(0, 3)
    const ranking = sorted.slice(3, 10)
    const hunters = sorted.slice(10, 12)

    const capitalizeName = (name) => {
        if (!name) return ""

        return name
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0)?.toUpperCase() + word.slice(1))
            .join(" ")
    }

    const month = () => {
        return new Date()
            .toLocaleString("pt-BR", {
                month: "long", year: "numeric",
            })
            ?.toUpperCase()
    }

    const max = sorted?.[0]?.total_registrations || 1
    const leaderDiff = (sorted?.[0]?.total_registrations || 0) - (sorted?.[1]?.total_registrations || 0)

    const podiumConfig = {
        1: {
            height: {base: "120px", md: "250px"},
            bg: "linear-gradient(180deg, #FFD54F 0%, #FFB300 100%)",
            border: "#f7ff00",
            color: "#111111",
            glow: "10px 10px 20px 10px rgba(255,215,0,.35)",
            avatar: {base: "35px", md: "65px"},
        },
        2: {
            height: {base: "110px", md: "190px"},
            bg: "linear-gradient(180deg, #E5E7EB 0%, #9CA3AF 100%)",
            border: "#ffffff",
            color: "#111111",
            glow: "12px 12px 24px 12px rgba(255,255,255,.30)",
            avatar: {base: "40px", md: "65px"},
        },
        3: {
            height: {base: "105px", md: "170px"},
            bg: "linear-gradient(180deg, #FB923C 0%, #C2410C 100%)",
            border: "#ff8300",
            color: "#111111",
            glow: "12px 12px 24px 12px rgba(251,146,60,.30)",
            avatar: {base: "35px", md: "55px"},
        },
    }

    return (
        <UI.Box
            bg="#020817"
            borderRadius="18px"
            border="1px solid"
            minW="100px"
            borderColor="rgba(255,255,255,.08)"
            boxShadow="0 0 20px rgba(0,0,0,.35)"
        >
            <VStack align="stretch" spacing={{base: 1, md: 2}}>
                <Box
                    bg="linear-gradient(180deg,#0B1023 0%, #030712 100%)"
                    borderBottom="1px solid"
                    borderColor="rgba(255,255,255,.06)"
                    p={{base: 2, md: 3}}
                >
                    <Flex
                        justify="space-between"
                        align="center"
                        flexWrap="wrap"
                        gap={1}
                    >
                        <HStack spacing={{base: 1.5, md: 2}}>
                            <Flex
                                w={{base: "24px", md: "32px"}}
                                h={{base: "24px", md: "32px"}}
                                borderRadius={{base: "8px", md: "10px"}}
                                bg="linear-gradient(180deg,#FFD54F,#FFB300)"
                                align="center"
                                justify="center"
                                fontSize={{base: "14px", md: "20px"}}
                            >
                                🏆
                            </Flex>

                            <Box>
                                <Text
                                    fontSize={{base: "13px", md: "18px"}}
                                    fontWeight="900"
                                    color="white"
                                    lineHeight="1.2"
                                >
                                    TOP 10 RECRUTADORES{" "}
                                    <Text as="span" color="#FFD54F">
                                        BNF
                                    </Text>
                                </Text>

                                <Text
                                    mt={{base: 0.5, md: 1}}
                                    fontSize={{base: "8px", md: "10px"}}
                                    color="gray.400"
                                    fontWeight="600"
                                    letterSpacing=".5px"
                                >
                                    REFERÊNCIA: {month()}
                                </Text>
                            </Box>
                        </HStack>

                        <Badge
                            bg="green.500"
                            color="white"
                            px={{base: 1.5, md: 2}}
                            py={0.5}
                            borderRadius="full"
                            fontSize={{base: "7px", md: "9px"}}
                            fontWeight="700"
                        >
                            AO VIVO
                        </Badge>
                    </Flex>

                    <SimpleGrid columns={3} gap={{base: 1.5, md: 2}} mt={{base: 2, md: 3}}>
                        <Box
                            p={{base: 1.5, md: 2}}
                            borderRadius={{base: "10px", md: "12px"}}
                            bg="rgba(255,255,255,.04)"
                            border="1px solid rgba(255,255,255,.08)"
                            textAlign="center"
                        >
                            <Text fontSize={{base: "12px", md: "24px"}}>🥈</Text>

                            <Text
                                fontSize={{base: "11px", md: "14px"}}
                                color="#FFD54F"
                                fontWeight="900"
                            >
                                <UI.Number.Amount value={prizes.second}/>
                            </Text>

                            <Text
                                fontSize={{base: "7px", md: "12px"}}
                                color="white"
                                fontWeight="800"
                                mt={{base: 0.5, md: 1}}
                            >
                                Em Produtos
                            </Text>
                        </Box>

                        <Box
                            p={{base: 1.5, md: 2}}
                            borderRadius={{base: "10px", md: "12px"}}
                            bg="rgba(255,255,255,.04)"
                            border="1px solid rgba(255,255,255,.08)"
                            textAlign="center"
                        >
                            <Text fontSize={{base: "12px", md: "24px"}}>🥇</Text>

                            <Text
                                fontSize={{base: "11px", md: "14px"}}
                                color="#FFD54F"
                                fontWeight="900"
                            >
                                <UI.Number.Amount value={prizes.first}/>
                            </Text>

                            <Text
                                fontSize={{base: "7px", md: "12px"}}
                                color="white"
                                fontWeight="800"
                                mt={{base: 0.5, md: 1}}
                            >
                                Em Produtos
                            </Text>
                        </Box>

                        <Box
                            p={{base: 1.5, md: 2}}
                            borderRadius={{base: "10px", md: "12px"}}
                            bg="rgba(255,255,255,.04)"
                            border="1px solid rgba(255,255,255,.08)"
                            textAlign="center"
                        >
                            <Text fontSize={{base: "12px", md: "24px"}}>🥉</Text>

                            <Text
                                fontSize={{base: "11px", md: "14px"}}
                                color="#FFD54F"
                                fontWeight="900"
                            >
                                <UI.Number.Amount value={prizes.third}/>
                            </Text>

                            <Text
                                fontSize={{base: "7px", md: "12px"}}
                                color="white"
                                fontWeight="800"
                                mt={{base: 0.5, md: 1}}
                            >
                                Em Produtos
                            </Text>
                        </Box>
                    </SimpleGrid>
                </Box>

                {sorted.length === 0 ? (
                    <Flex py={8} justify="center">
                        <Text color="white">Nenhum registro</Text>
                    </Flex>
                ) : (
                    <>
                        <Flex
                            justify="center"
                            align="flex-end"
                            gap={{base: 0.5, md: 1.5}}
                            px={{base: 1, md: 2}}
                            pt={{base: 2, md: 5}}
                            pb={{base: 1.5, md: 3}}
                            bg="radial-gradient(circle at top, rgba(255,193,7,.12), transparent 45%)"
                        >
                            {[2, 1, 3].map((position) => {
                                const item = podium[position - 1]
                                if (!item) return null
                                const config = podiumConfig[position]
                                const isLeader = position === 1

                                return (
                                    <Box
                                        key={position}
                                        w={position === 1 ? {base: "105px", md: "170px"} : {base: "85px", md: "135px"}}
                                        h={config.height}
                                        position="relative"
                                        borderRadius={{base: "12px", md: "18px"}}
                                        bg={config.bg}
                                        border="2px solid"
                                        borderColor={config.border}
                                        overflow="hidden"
                                        boxShadow={config.glow}
                                    >
                                        <Flex
                                            position="absolute"
                                            top={{base: "4px", md: "5px"}}
                                            left={{base: "4px", md: "7px"}}
                                            w={{base: "16px", md: "24px"}}
                                            h={{base: "16px", md: "24px"}}
                                            borderRadius="full"
                                            bg="rgba(0,0,0,.22)"
                                            align="center"
                                            justify="center"
                                            fontWeight="900"
                                            fontSize={{base: "9px", md: "14px"}}
                                            color={config.color}
                                            zIndex={2}
                                        >
                                            {position}
                                        </Flex>

                                        <VStack
                                            h="100%"
                                            justify="center"
                                            spacing={{base: 0.5, md: 1}}
                                            position="relative"
                                            zIndex={1}
                                        >
                                            <UI.Avatar
                                                w={config.avatar}
                                                h={config.avatar}
                                                bg="rgba(0,0,0,.25)"
                                                border="2px solid rgba(255,255,255,.8)"
                                                color="white"
                                                src={item.avatar}
                                                name={item.consultant_name}
                                            />

                                            <Box>
                                                <Text
                                                    textAlign="center"
                                                    fontSize={{base: "9px", md: isLeader ? "15px" : "13px"}}
                                                    fontWeight={{base: "800", md: "900"}}
                                                    lineHeight="1.2"
                                                    color={config.color}
                                                    px={{base: 0.5, md: 1.5}}
                                                    noOfLines={{base: 1, md: 2}}
                                                >
                                                    {capitalizeName(item.consultant_name)}
                                                </Text>
                                                {(item.city_name || item.state_name) && (
                                                    <Text
                                                        textAlign="center"
                                                        fontSize={{base: "8px", md: isLeader ? "13px" : "11px"}}
                                                        lineHeight="1.2"
                                                        color={config.color}
                                                        px={{base: 0.5, md: 1.5}}
                                                        noOfLines={{base: 1, md: 2}}
                                                    >
                                                        ({capitalizeName(item.city_name || "")}/{item.state_name ? item.state_name.toUpperCase() : ""})
                                                    </Text>
                                                )}
                                            </Box>

                                            <Text
                                                fontSize={{base: "22px", md: isLeader ? "44px" : "34px"}}
                                                fontWeight="900"
                                                lineHeight=".9"
                                                color={config.color}
                                            >
                                                {item.total_registrations}
                                            </Text>

                                            <Text
                                                fontSize={{base: "7px", md: "10px"}}
                                                fontWeight="800"
                                                letterSpacing={{base: "0.5px", md: "1px"}}
                                                color={config.color}
                                            >
                                                CADASTROS
                                            </Text>

                                            {isLeader && (
                                                <Badge
                                                    borderRadius="full"
                                                    bg="rgba(0,0,0,.25)"
                                                    color="white"
                                                    fontSize={{base: "7px", md: "14px"}}
                                                >
                                                    <Text fontWeight="bold" fontSize={{base: "10px", md: "14px"}}>
                                                        +{leaderDiff} Acima do 2°
                                                    </Text>
                                                </Badge>
                                            )}
                                        </VStack>
                                    </Box>
                                )
                            })}
                        </Flex>

                        <Box px={{base: 2, md: 3}} pb={{base: 1.5, md: 3}}>
                            <VStack spacing={2} align="stretch">
                                {sorted.slice(0, 3).map((item, index) => (
                                    <Box key={index}>
                                        <Flex justify="space-between" mb={0.5}>
                                            <Text color="white" fontWeight="700" fontSize={{base: "9px", md: "xs"}}>
                                                {index + 1}º
                                            </Text>
                                            <Text color="#FFD54F" fontWeight="900"
                                                  fontSize={{base: "11px", md: "15px"}}>
                                                {item.total_registrations}
                                            </Text>
                                        </Flex>
                                        <Box h={{base: "4px", md: "6px"}} borderRadius="full" bg="rgba(255,255,255,.08)"
                                             overflow="hidden">
                                            <Box
                                                h="100%"
                                                w={`${(item.total_registrations / max) * 100}%`}
                                                borderRadius="full"
                                                bg={index === 0 ? "linear-gradient(90deg,#FFD54F,#FFB300)" : index === 1 ? "linear-gradient(90deg,#E5E7EB,#9CA3AF)" : "linear-gradient(90deg,#FB923C,#C2410C)"}
                                            />
                                        </Box>
                                    </Box>
                                ))}
                            </VStack>
                        </Box>

                        <Box
                            mx={{base: 2.5, md: 4}}
                            borderRadius={{base: "14px", md: "16px"}}
                            overflow="hidden"
                            border="1px solid rgba(255,255,255,.08)"
                            bg="rgba(255,255,255,.02)"
                        >
                            <VStack spacing={0} align="stretch">
                                {ranking.map((item, index) => {
                                    const position = index + 4
                                    return (
                                        <Flex
                                            key={index}
                                            px={{base: 1.5, md: 2.5}}
                                            py={{base: 1, md: 1.5}}
                                            align="center"
                                            justify="space-between"
                                            borderBottom={index === ranking.length - 1 ? "none" : "1px solid rgba(255,255,255,.05)"}
                                        >
                                            <HStack spacing={{base: 1, md: 2}}>
                                                <Text minW="22px" color="white" fontWeight="900"
                                                      fontSize={{base: "14px", md: "18px"}}>
                                                    {position}º
                                                </Text>
                                                <Box>
                                                    <Text fontSize={{base: "11px", md: "14px"}}
                                                          fontWeight={{base: "600", md: "700"}} color="white">
                                                        {capitalizeName(item.consultant_name)}
                                                    </Text>
                                                    {(item.city_name || item.state_name) && (
                                                        <Text fontSize={{base: "9px", md: "11px"}} color="gray.300">
                                                            ({capitalizeName(item.city_name || "")}/{item.state_name ? item.state_name.toUpperCase() : ""})
                                                        </Text>
                                                    )}
                                                </Box>
                                            </HStack>
                                            <Text color="white" fontWeight="900" fontSize={{base: "11px", md: "18px"}}>
                                                {item.total_registrations}
                                            </Text>
                                        </Flex>
                                    )
                                })}
                            </VStack>
                        </Box>

                        {hunters.length > 0 && (
                            <Box
                                mx={{base: 2, md: 3}}
                                mt={{base: 2, md: 3}}
                                p={{base: 2, md: 3}}
                                borderRadius={{base: "12px", md: "14px"}}
                                bg="linear-gradient(90deg,#1E1B4F,#111827)"
                                border="1px solid rgba(255,255,255,.08)"
                            >
                                <Text
                                    color="#FFD54F"
                                    fontWeight="900"
                                    fontSize={{base: "8px", md: "11px"}}
                                    mb={{base: 1.5, md: 2}}
                                    textAlign="center"
                                >
                                    ⚡ CAÇADORES DO TOP 10
                                </Text>
                                <SimpleGrid columns={2} gap={{base: 1, md: 2}}>
                                    {hunters.map((item, index) => {
                                        const position = 11 + index
                                        return (
                                            <Flex
                                                key={index}
                                                align="center"
                                                justify="space-between"
                                                p={{base: 1, md: 2}}
                                                borderRadius={{base: "8px", md: "10px"}}
                                                bg="rgba(255,255,255,.04)"
                                                gap={{base: 1, md: 2}}
                                            >
                                                <HStack spacing={{base: 1, md: 2}} flex={1}>
                                                    <Text color="gray.100" fontSize={{base: "10px", md: "13px"}}
                                                          fontWeight="800" minW="20px">
                                                        {position}°
                                                    </Text>
                                                    <UI.Avatar src={item.avatar} name={item.consultant_name}
                                                               size={{base: "xs", md: "sm"}} borderWidth={1.5}/>
                                                    <Box flex={1}>
                                                        <Text color="white" fontWeight={{base: "600", md: "700"}}
                                                              fontSize={{base: "9px", md: "12px"}} noOfLines={1}>
                                                            {capitalizeName(item.consultant_name)}
                                                        </Text>
                                                        {(item.city_name || item.state_name) && (
                                                            <Text color="gray.300" fontSize={{base: "7px", md: "10px"}}
                                                                  noOfLines={1}>
                                                                (
                                                                {capitalizeName(item.city_name || "")}
                                                                /{item.state_name ? item.state_name.toUpperCase() : ""})
                                                            </Text>
                                                        )}
                                                    </Box>
                                                </HStack>
                                                <Text color="white" fontWeight="900"
                                                      fontSize={{base: "11px", md: "18px"}}>
                                                    {item.total_registrations}
                                                </Text>
                                            </Flex>
                                        )
                                    })}
                                </SimpleGrid>
                            </Box>
                        )}

                        <Box p={{base: 2, md: 3}}>
                            <Flex
                                p={{base: 2, md: 3}}
                                borderRadius={{base: "12px", md: "16px"}}
                                bg="linear-gradient(90deg,#111827,#052E16)"
                                border="1px solid rgba(34,197,94,.25)"
                                align="center"
                                justify="space-between"
                                gap={{base: 1.5, md: 3}}
                                direction={{base: "column", md: "row"}}
                                textAlign={{base: "center", md: "left"}}
                            >
                                <HStack spacing={{base: 1, md: 2}}>
                                    <Text fontSize={{base: "md", md: "xl"}}>🚀</Text>
                                    <Box>
                                        <Text color="white" fontWeight="900" fontSize={{base: "11px", md: "16px"}}>
                                            QUER APARECER AQUI?
                                        </Text>
                                        <Text mt={{base: 0.5, md: 1}} color="gray.300"
                                              fontSize={{base: "9px", md: "12px"}}>
                                            Continue recrutando
                                        </Text>
                                    </Box>
                                </HStack>
                                <Button
                                    borderRadius={{base: "10px", md: "12px"}}
                                    bg="green.700"
                                    color="white"
                                    fontWeight={{base: "800", md: "900"}}
                                    fontSize={{base: "10px", md: "11px"}}
                                    size={{base: "xs", md: "sm"}}
                                    w={{base: "100%", md: "auto"}}
                                    px={{base: 2, md: 3}}
                                    py={{base: 1, md: 1.5}}
                                    h="auto"
                                    _hover={{bg: "green.400"}}
                                    onClick={dialog.onOpen}
                                >
                                    CADASTRAR
                                </Button>
                            </Flex>
                        </Box>
                    </>
                )}
            </VStack>
            <Parts.Dialog.Indication {...dialog} />
        </UI.Box>
    )
}